import { VendedorDTO } from 'app/main/a2w/supervisor/cadastros/parceiros-negocios/vendedor/vendedor.model';
import { EmpresaDTO } from 'app/shared/empresa.model';
import { Funcoes } from 'app/shared/funcoes.mode';

export class userDetail{
    userId: string;
    accountId: string;
    password: string;
    nmAssinatura: string; 
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    developmentUser: boolean;
    mainUser: boolean;
    activated: boolean;
    twoFactorEnabled: boolean;
    twoFactorPassword: string;
    groupName: string;
    userGroupId: string;
    vendedorId: number;
    userImage: string;
    accountName: string;
    filiaisGestor: string;
    clientesDistribuidor: string;
    usuariosGestor: string;
    listaFiliaisGestor: any[];
    listaClientesDistribuidor: any[];
    listaUsuariosGestor: any[];
    userRules: Funcoes[];
    listaFiliaisVendedor: EmpresaDTO[];
    listaFiliaisVendedorOperacoes: EmpresaDTO[];
    vendedorUsuarioLogado: VendedorDTO;
    listaEmpresasUsuariosGestor: EmpresaDTO[];
    ultimoAcessoWeb: any;
    ultimoAcessoApp: any;
    ultimoLogin: any;
    googleCalendarAuthenticated: boolean;
    // DATA DO ACEITE DA VERSÃO VIGENTE; null = PENDENTE
    dataAceiteTermos: string | null;
    termoPendente: boolean;
    versaoVigente: number | null;
    moduloPedidos: boolean;
    moduloAtividades: boolean;
    tipoERP: number;
    visualizarOperacoesColaboradoresVinculados: boolean;

    constructor(values?){
        values = values || {};
        this.userId = values.userId || '';
        this.accountId = values.accountId || '';
        this.password = values.password || '';
        this.nmAssinatura = values.nmAssinatura || '';
        this.username = values.username || '';
        this.firstName = values.firstName || '';
        this.lastName = values.lastName || '';
        this.email = values.email || '';
        this.phoneNumber = values.phoneNumber || '';
        this.developmentUser = values.developmentUser || false;
        this.mainUser = values.mainUser || false;
        this.activated = values.activated || false;
        this.twoFactorEnabled = values.twoFactorEnabled || false;
        this.twoFactorPassword = values.twoFactorPassword || '';
        this.groupName = values.groupName || '';
        this.userGroupId = values.userGroupId || '';
        this.vendedorId = values.vendedorId || 0;
        this.userImage = values.userImage || '';
        this.accountName = values.accountName || '';
        this.filiaisGestor = values.filiaisGestor || '';
        this.clientesDistribuidor = values.clientesDistribuidor || '';
        this.usuariosGestor = values.usuariosGestor || '';
        this.userRules = values.userRules || [];
        this.listaFiliaisGestor = values.listaFiliaisGestor || [];
        this.listaUsuariosGestor = values.listaUsuariosGestor || [];
        this.listaClientesDistribuidor = values.listaClientesDistribuidor || [];
        this.listaFiliaisVendedor = values.listaFiliaisVendedor || [];
        this.listaFiliaisVendedorOperacoes = values.listaFiliaisVendedorOperacoes || [];
        this.vendedorUsuarioLogado = values.vendedorUsuarioLogado || '';
        this.listaEmpresasUsuariosGestor = values.listaEmpresasUsuariosGestor || [];
        this.ultimoAcessoWeb = values.ultimoAcessoWeb || '';
        this.ultimoAcessoApp = values.ultimoAcessoApp || '';
        this.ultimoLogin = values.ultimoLogin || '';
        this.googleCalendarAuthenticated = values.googleCalendarAuthenticated || false;
        this.dataAceiteTermos = values.dataAceiteTermos || null;
        this.termoPendente = values.termoPendente || false;
        this.versaoVigente = values.versaoVigente ?? null;
        this.tipoERP = values.userDetails || 0;
        this.visualizarOperacoesColaboradoresVinculados = values.visualizarOperacoesColaboradoresVinculados || false;
    }
}
